// Whether an image URL still serves a file, shared by the image rows and the broken-images banner.
// url -> true (broken) | false (loads) | null (probe in flight)
const results = {};
const waiting = {};

// Shopify's CDN answers a deleted file's versioned URL from its caches, some edge servers with the
// old file and some with a 404, so the probe drops `v`; the unique param keeps every cache out
const probeUrl = (url) => {
  const probe = new URL(url);
  if(probe.hostname === 'cdn.shopify.com') probe.searchParams.delete('v');
  probe.searchParams.set('ly_probe', String(Date.now()));
  return probe.toString();
};

// the CDN allows CORS, so a HEAD request reads the status without downloading the file
const probeShopifyCdn = (url, done) => {
  fetch(probeUrl(url), { method: 'HEAD', cache: 'no-store' })
    .then(res => done(res.ok ? false : (res.status === 404 || res.status === 410) ? true : undefined))
    .catch(() => done(undefined));
};

// other hosts may not allow CORS: an image load, which cannot tell a 404 from any other failure
const probeByImage = (url, done) => {
  const image = new Image();
  image.onload = () => done(false);
  image.onerror = () => done(true);
  let src = url;
  try { if(/^https?:\/\//i.test(url)) src = probeUrl(url); } catch (e) { /* keep the URL as it is */ }
  image.src = src;
};

export const imageProbeResult = (url) => results[url];

// callback(broken): true, false, or undefined when the probe could not decide (not cached, the
// next call probes again). recheck probes a URL again that loaded before: the file may be gone
export const probeImage = (url, callback, recheck = false) => {
  const cached = results[url];
  if(cached === true || (cached === false && !recheck)) { callback(cached); return; }
  if(waiting[url]) { waiting[url].push(callback); return; }
  waiting[url] = [callback];
  results[url] = null;

  let isShopifyCdn = false;
  try { isShopifyCdn = new URL(url).hostname === 'cdn.shopify.com'; } catch (e) { /* not a URL */ }
  (isShopifyCdn ? probeShopifyCdn : probeByImage)(url, broken => {
    if(broken === undefined) delete results[url];
    else results[url] = broken;
    const callbacks = waiting[url];
    delete waiting[url];
    callbacks.forEach(cb => cb(broken));
  });
};
